export const announcementsOrgPermissions = {
    /**
     * Announcements management.
     * Allow to edit organization's announcement title, body, access, date and status.
     */
    'manage-org-announcements': {
        label: 'Manage Organization Announcements',
        group: 'Announcements',
    },
};
